import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExpandLessSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExpandLessSVG;
